import { Alert, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useGetOmniDashboardUrlMutation } from '../../api/apigQuery';

/**
 * OMNI Reporting Dashboard - Full page iframe embed
 */
export function OmniReporting() {
  const [getOmniDashboardUrl, { data, isLoading, error }] =
    useGetOmniDashboardUrlMutation();

  useEffect(() => {
    // Fetch the dashboard URL when component mounts
    getOmniDashboardUrl({
      prefersDark: localStorage?.getItem?.('themeMode') === 'dark-mode',
      userSettings: undefined,
    });
  }, [getOmniDashboardUrl]);

  // Hide Intercom launcher on Omni page
  useEffect(() => {
    // Hide Intercom if it exists
    if (window.Intercom) {
      window.Intercom('update', { hide_default_launcher: true });
    }

    // Cleanup: show Intercom when leaving the page
    return () => {
      if (window.Intercom) {
        window.Intercom('update', {
          alignment: 'right',
          horizontal_padding: 20,
          vertical_padding: 20,
        });
      }
    };
  }, []);

  // Debug logging
  useEffect(() => {
    if (data) {
      console.log('OMNI Dashboard API Response:', data);
      console.log('iframe URL:', data?.iframeUrl);
    }
    if (error) {
      console.error('OMNI Dashboard API Error:', error);
    }
  }, [data, error]);

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (error || !data?.iframeUrl) {
    console.error('Failed to load OMNI dashboard:', { error, data });
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
          padding: '20px',
        }}
      >
        <Alert severity="error">
          Failed to load dashboard. Please try again later.
          {data && <div>Data: {JSON.stringify(data, null, 2)}</div>}
        </Alert>
      </div>
    );
  }

  return (
    <iframe
      src={data.iframeUrl}
      title="OMNI Reporting Dashboard"
      style={{
        width: '100vw',
        height: '100vh',
        border: 'none',
        margin: 0,
        padding: 0,
        display: 'block',
      }}
    />
  );
}
